module.exports = __webpack_public_path__ + "assets/mollie-secured.053e8508.svg";